export default {
  accepted: 'Хүлээн авсан',
  accessRequestDate: 'Нэвтрэх хүсэлт гаргасан огноо',
  confirmUserWillBeSystemAdmin: 'Хэрэглэгч систем администратор болно. Үргэлжлүүлэх үү?',
  copyInvitationLink: 'Урилгын холбоосыг санах ойд хуулах',
  copyInvitationLinkConfirmMessage: `Хэрэв уригдсан хэрэглэгч {{email}} хаяг руу имэйл хүлээн аваагүй бол,
та урилгын холбоосыг санах ойд хуулаад түүнтэй өөр аргаар хуваалцах боломжтой.

Урилгын холбоосыг санах ойд хуулах уу?`,
  copyPasswordResetLink: 'Нууц үг сэргээх холбоосыг санах ойд хуулах уу?',
  passwordResetLinkCopiedToClipboard: 'Нууц үг сэргээх холбоосыг санах ойд хуулсан',
  passwordResetLink: 'Нууц үг сэргээх холбоос',
  copyPasswordResetLinkConfirmMessage: `Хэрэв хэрэглэгч нууц үгээ сэргээсэн боловч {{email}} хаяг руу имэйл хүлээн аваагүй бол,
та нууц үг сэргээх холбоосыг санах ойд хуулаад түүнтэй өөр аргаар хуваалцах боломжтой.

Нууц үг сэргээх холбоосыг санах ойд хуулах уу?`,
  editSurveyUserExtraPropsForUser: 'Хэрэглэгч "{{userName}}"-ийн судалгааны нэмэлт шинж чанаруудыг засах',
  inviteUser: 'Урих',
  invitationExpiredClickToSendAgainTheInvitation: 'Урилга дууссан: урилгыг дахин илгээхийн тулд дарна уу',
  invitationLinkCopiedToClipboard: 'Урилгын холбоосыг таны санах ойд хуулсан',
  invitedBy: 'Урьсан',
  invitedDate: 'Урьсан огноо',
  lastLogin: 'Сүүлийн нэвтрэлт',
  moreThan30DaysAgo: '30 гаруй хоногийн өмнө',
  notAcceptedYet: 'Урилгыг хараахан хүлээн аваагүй байна',
  prefs: {
    title: 'Мэдэгдлийн тохиргоо',
    notifyOnUserAccessRequest: 'Шинэ хэрэглэгчийн хандалтын хүсэлт',
  },
  roleInCurrentSurvey: 'Одоогийн судалгаан дахь үүрэг',
  roleInSurvey: 'Судалгаан дахь үүрэг',
  filterPlaceholder: 'Нэр эсвэл имэйлээр шүүх',
  surveyName: 'Судалгааны нэр',
  surveyExtraProp: {
    label: 'Судалгааны нэмэлт шинж чанар',
    label_other: 'Судалгааны нэмэлт шинж чанарууд',
  },
  surveysDraft: 'Судалгаанууд (ноорог)',
  surveysPublished: 'Судалгаанууд (нийтлэгдсэн)',
  userRemovedFromSurveyGoToSurveysRequired: `Та энэ судалгаанаас хасагдсан байна.  
Судалгааны жагсаалтыг нээхийн тулд Судалгааны жагсаалт руу очих товчийг дарна уу.`,
  userRoleUpdatedRefreshRequired: `Таны энэ судалгаан дахь үүрэг шинэчлэгдлээ.  
$t(common.pressRefreshToReloadPage)`,
  userGroup: {
    new: 'Шинэ бүлэг',
    edit: 'Бүлэг засах',
    name: 'Нэр',
    label: 'Шошго',
    qualifier: 'Тодотгол {{index}}',
    qualifier_plural: 'Тодотголууд',
    qualifierKey: 'Түлхүүр',
    qualifierValue: 'Утга',
    addQualifier: 'Тодотгол нэмэх',
    members: 'Гишүүд',
    addMember: 'Гишүүн нэмэх',
    noMembers: 'Гишүүн байхгүй байна',
    memberAlreadyInGroup: '"{{groupName}}" бүлэгт байна',
    tabs: {
      groups: 'Хэрэглэгчийн бүлгүүд',
      assignments: 'Гишүүдийн хуваарилалт',
      report: 'Гишүүдийн тайлан',
    },
    memberName: 'Гишүүний нэр',
    memberEmail: 'Гишүүний имэйл',
    memberRole: 'Судалгаан дахь үүрэг',
    memberStatus: 'Төлөв',
    status: {
      INVITED: 'Урьсан',
      ACCEPTED: 'Хүлээн авсан',
      FORCE_CHANGE_PASSWORD: 'Нууц үг солих шаардлагатай',
    },
    unassigned: 'Хуваарилагдаагүй',
    confirmDelete: '"{{name}}" бүлгийг устгах уу? Гишүүд нь хуваарилагдаагүй болно. Үргэлжлүүлэх үү?',
    deleteConfirmed: '"{{name}}" бүлэг устгагдлаа',
    saveConfirmed: '"{{name}}" бүлэг хадгалагдлаа',
    confirmReassign: '{{userName}} одоогоор "{{groupName}}" бүлэгт байна. Үүний оронд энэ бүлэгт шилжүүлэх үү?',
    notFound: 'Бүлэг олдсонгүй',
  },
  updateUserConfirmation: 'Хэрэглэгч {{name}} шинэчлэгдсэн',
  userNotInvitedToAnySurvey: `Хэрэглэгчийг ямар ч судалгаанд уриагүй байна`,
  userSurveys: 'Хэрэглэгчийн судалгаанууд',
}
